export default {
  name: 'ComoFunciona',
  props: {
    title: {
      type: String,
      default: 'Como funciona'
    }
  }
}
